module.exports = __webpack_public_path__ + "img/all-pages-active.0108546.svg";